import React from 'react';
import PropTypes from 'prop-types';
import logger from '@common/Utility/logger';
import ErrorPage from '../ErrorPage/ErrorPage';
import { ErrorBoundaryContext } from './ErrorBoundaryContext';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  // eslint-disable-next-line node/handle-callback-err
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error) {
    this.setState({
      hasError: true,
    });
    logger.error('javascript client side error occured', error);
  }

  triggerError = () => {
    this.setState({ hasError: true });
  };

  resetError = () => this.setState({ hasError: false });

  render() {
    return (
      <ErrorBoundaryContext.Provider value={{ triggerError: this.triggerError, resetError: this.resetError }}>
        {this.state.hasError ? <ErrorPage page="something_went_wrong" history = {this.props.history} /> : this.props.children}
      </ErrorBoundaryContext.Provider>
    );
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any,
  error: PropTypes.bool,
  history: PropTypes.string,
};

export default ErrorBoundary;
